import { createContext, useContext } from "react";
import type { User } from "firebase/auth";

export type AuthContextValue = {
  user: User | null;
  signInWithGoogle?: () => Promise<void>;
  signInWithGitHub?: () => Promise<void>;
  signOut?: () => Promise<void>;
  isAdmin?: boolean;
  isManager?: boolean;
  refreshClaims?: () => Promise<void>;
};

export const AuthContext = createContext<AuthContextValue | undefined>(
  undefined
);

export const useAuth = (): AuthContextValue => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within an AuthProvider");
  return ctx;
};

export default AuthContext;
